import { formatNumber } from "../../../utils/common-function";
import Box from "@material-ui/core/Box";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import DescriptionIcon from "@material-ui/icons/Description";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { ToDateTimeText } from "../../../utils/date";

export const getMasterTemplateColumns = (
  deleteTemplateMaster,
  editTemplate,
  viewHistoryTemplate
) => {
  const columns = [
    {
      dataField: "OP2",
      text: "",
      formatter: (cell, row) => {
        return (
          <Box component="div" display="flex" justifyContent="center">
            <EditIcon
              color="action"
              onClick={() => {
                editTemplate(row);
              }}
            />
            <DeleteIcon
              color="action"
              onClick={() => {
                deleteTemplateMaster(row.TEMPLATE_ID);
              }}
            />
            <DescriptionIcon
              color="action"
              onClick={() => {
                viewHistoryTemplate(row);
              }}
            />
          </Box>
        );
      },
    },
    {
      dataField: "HOST_TITLE",
      text: "Host Title",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "TEMPLATE_ID",
      text: "Template ID",
      sort: true,
      headerAlign: "center",
      align: "center",
      formatter: (cell, row, rowIndex) => {
        return <>{formatNumber(row.TEMPLATE_ID, 5)}</>;
      },
    },
    {
      dataField: "TEMPLATE_NAME",
      text: "Template Name",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "VERSION",
      text: "Version",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "TARGET_TABLE",
      text: "Target Table",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
  ];
  return columns;
};

export const getMasterTemplateHistoryColumns = (
  downloadTemplate,
  viewHistoryTemplate
) => {
  const columns = [
    {
      dataField: "OP2",
      text: "",
      formatter: (cell, row) => {
        return (
          <Box component="div" display="flex" justifyContent="center">
            <CloudDownloadIcon
              color="action"
              onClick={() => {
                downloadTemplate(row);
              }}
            />
            <DescriptionIcon
              color="action"
              onClick={() => {
                viewHistoryTemplate(row);
              }}
            />
          </Box>
        );
      },
    },
    {
      dataField: "HOST_TITLE",
      text: "Host Title",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "TEMPLATE_ID",
      text: "Template ID",
      sort: true,
      headerAlign: "center",
      align: "center",
      formatter: (cell, row, rowIndex) => {
        return <>{formatNumber(row.TEMPLATE_ID, 5)}</>;
      },
    },
    {
      dataField: "TEMPLATE_NAME",
      text: "Templaet Name",
      sort: true,
    },
    {
      dataField: "VERSION",
      text: "Version",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "TARGET_TABLE",
      text: "Target table",
      sort: true,
    },
    {
      dataField: "PATH_FILE_OLD",
      text: "File Name",
      sort: true,
    },

    {
      dataField: "CREATE_DATE",
      text: "Upload Date",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { minWidth: "150px", textAlign: "center" };
      },
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateTimeText(row.CREATE_DATE)}</>;
      },
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "CREATE_BY",
      text: "Upload By",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
  ];
  return columns;
};
